export const getEntityId = (fullId: string) => {
  const parts = fullId.split('#');
  return parts[parts.length - 1];
};

export const toNumber = (number?: number | string | null) => {
  if (typeof number === 'number' && !isNaN(number)) return number;
  const num = Number(number);
  return isNaN(num) ? 0 : num;
};
